import script from "./ConsultationModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ConsultationModal.vue?vue&type=script&setup=true&lang=js"

import "./ConsultationModal.vue?vue&type=style&index=0&id=22310ef0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22310ef0"]])

export default __exports__